module.exports = __webpack_public_path__ + "media/images/icons/officials_statistics-22646f02fa2f37622fba81366bfa4265.svg";